import { AlertTriangle } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface DashboardErrorStateProps {
  message?: string;
  onRetry: () => void;
}

export function DashboardErrorState({ message, onRetry }: DashboardErrorStateProps) {
  return (
    <Card className="border-destructive/30">
      <CardHeader>
        <CardTitle className="text-base">Impossibile caricare la dashboard</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="flex items-start gap-2 text-sm text-muted-foreground">
          <AlertTriangle className="mt-0.5 h-4 w-4 text-destructive" />
          <span>{message ?? "Si e' verificato un errore di rete o autenticazione."}</span>
        </div>
        <Button type="button" onClick={onRetry}>
          Riprova
        </Button>
      </CardContent>
    </Card>
  );
}
